import Layout from '@/components/v2/Layout';
import UserInfoForm from '@/components/v2/UserInfoForm';

const MemberCenter = () => {
  return (
    <Layout>
      <UserInfoForm />
    </Layout>
  );
};

export default MemberCenter;
